import React, { useState } from "react";
import "@/assets/css/ProductCard.css";
import { ProductCardProps } from "@/types/product";
import ProductDetails from "./ProductDetails/ProductDetails";
import comingSoonImage from "../../assets/img/comingSoon.jpeg";
import LazyImage from "@/components/ui/LazyImage";

const ProductCard: React.FC<ProductCardProps> = ({ product }) => {
  const [showProductDetails, setShowProductDetails] = useState(false);

  const handleModalOpen = () => {
    setShowProductDetails(true);
  };

  const handleModalClose = () => {
    setShowProductDetails(false);
  };
  const outOfStock = !product.in_stock;
  const isPhysicalProduct = product.product_type === "Physical Product";
  const unavailable = !product.is_available;
  const isService = product.product_type === "Service";
  const toDisable =
    (outOfStock && isPhysicalProduct) || (unavailable && isService);

  return (
    <div
      className="md:w-full md:my-8 md:rounded-lg 
                md:shadow-[0_0_15px_rgba(0,0,0,0.2)] md:h-60 md:px-12 md:py-10"
    >
      <button
        className={`w-full h-[7rem] my-2 border-b-2 border-grayCloud flex text-left
                    md:border-0 md:h-full md:my-0 justify-between`}
        onClick={handleModalOpen}
        disabled={toDisable}
      >
        <div className={"w-[64%] h-full flex flex-col justify-between pb-5"}>
          <p
            className={`product-name font-bold text-base md:text-xl  ${toDisable ? "opacity-30" : ""}`}
          >
            {product.name}
          </p>
          <div
            className={`product-description-container ${toDisable ? "opacity-30" : ""}`}
          >
            <p className="product-description text-xs md:text-sm font-normal min-h-[2rem]">
              {product.description}
            </p>
          </div>
          <div className="flex items-center">
            <p
              className={`text-xs md:text-lg font-bold ${toDisable ? "opacity-30" : ""}`}
            >
              {Number(product.unit_price) === 0
                ? "Priced by Add-ons"
                : "$" + product.unit_price}
            </p>
            {outOfStock && isPhysicalProduct && (
              <span className="text-redCrimson ml-2 font-bold text-xs md:text-lg">
                Out of Stock
              </span>
            )}
            {unavailable && isService && (
              <span className="text-redCrimson ml-2 font-bold text-xs md:text-lg">
                Unavailable
              </span>
            )}
          </div>
        </div>

        <div
          className={`md:flex md:h-full md:items-center md:justify-center ${(outOfStock && isPhysicalProduct) || (unavailable && isService) ? "opacity-30" : ""}`}
        >
          <LazyImage
            src={product.image || comingSoonImage}
            alt={product.name}
            className="w-24 h-24 rounded-lg md:w-36 md:h-36 object-cover"
          />
        </div>
      </button>
      <ProductDetails
        isModalOpen={showProductDetails}
        handleModalClose={handleModalClose}
        product={product}
      />
    </div>
  );
};

export default ProductCard;
